
import {DoOpeningHourFactory} from './do-opening-hour-factory';
import {DoDoctor} from '../../interfaces/doctors/do-doctor';
import {DoOpeningHour} from '../../interfaces/doctors/do-opening-hour';

export class DoDoctorFactory {

  /**
   *
   * @param doDoctor
   */
  public static fromObject(doDoctor: any): DoDoctor {
    return new class implements DoDoctor {
      customId: number = doDoctor.custom_id;
      fullRoute: string = doDoctor.full_route;
      door: string = doDoctor.door;
      email: string = doDoctor.email;
      firstName: string = doDoctor.first_name;
      floor: string = doDoctor.floor;
      genderId: number = doDoctor.gender_id;
      id: number = doDoctor.id;
      lastName: string = doDoctor.last_name;
      fullName: string = doDoctor.full_name;
      locality: string = doDoctor.locality;
      longitude: number = doDoctor.longitude;
      latitude: number = doDoctor.latitude;
      phone1: string = doDoctor.phone_1;
      phone2: string = doDoctor.phone_2;
      phone3: string = doDoctor.phone_3;
      postalCode: string = doDoctor.postal_code;
      route: string = doDoctor.route;
      comment: string = doDoctor.address_note;
      streetNumber: string = doDoctor.street_number;
      titlePrefix: string = doDoctor.title_prefix;
      titleSuffix: string = doDoctor.title_suffix;
      website: string = doDoctor.website;
      countryId: number = doDoctor.country_id;
      doOpeningHours: DoOpeningHour[] =
        DoOpeningHourFactory.fromArray(doDoctor.do_opening_hours);
    };
  }

  /**
   *
   * @param doDoctors
   */
  public static fromArray(doDoctors: any[]): DoDoctor[] {
    return doDoctors.map(_doDoctor => DoDoctorFactory.fromObject(_doDoctor));
  }
}
